import { CSSProperties } from 'react';
import ReactTooltip, { TooltipProps } from 'react-tooltip';

import styled from '@emotion/styled';

import Typography from '../Typography';
import { useDefaultProps } from './hooks';
import useIsClientSide from './useIsClientSide';

interface Props extends TooltipProps {
  style?: CSSProperties | undefined;
}

const ReactTooltipStyled = styled(ReactTooltip)`
  &&&.__react_component_tooltip.place-top::before {
    height: 0;
  }
`;

export function Tooltip({
  textColor,
  backgroundColor,
  border,
  borderColor,
  children,
  style,
  ...props
}: Props) {
  const defaultProps = useDefaultProps();
  const isClient = useIsClientSide();

  if (!isClient) {
    return null;
  }
  return (
    <ReactTooltipStyled
      backgroundColor={backgroundColor ?? defaultProps.backgroundColor}
      border={border ?? defaultProps.border}
      textColor={textColor ?? defaultProps.textColor}
      borderColor={borderColor ?? defaultProps.borderColor}
      {...props}
    >
      <Typography
        variant="caption1"
        color={textColor ?? defaultProps.textColor}
        className="py-1 text-center break-keep"
        style={style}
      >
        {children}
      </Typography>
    </ReactTooltipStyled>
  );
}
